export default {
  default: () => import("/app/50-ftd-20-frl-gllo/layouts/default.vue")
}